
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import cancelledImg from "~/assets/images/cancelled-stamp.png";
import Vue from "vue";
import OrderBarcode from "../reciever/order-barcode.vue";
import QrCode from "./qr-code.vue";
export default {
  components: {
    OrderBarcode
  },
  data() {
    return {
      cancelledImg: cancelledImg,
      MAX_CHAR_LENGTH: 48,
      barcodeImage: null
    };
  },
  created() {
    this.initQzSettings();
    this.startConnection();
  },
  beforeMount() {},
  mounted() {
    this.$nuxt.$on("initiate-print", this.initiatePrint);
    this.$nuxt.$on("re-start-connection", this.startConnection);
  },
  computed: {
    ...mapState("restaurant", [
      "locationDetails",
      "printers",
      "businessDetails"
    ]),
    ...mapGetters("restaurant", ["hasMultipleBrands", "getRestaurantName"]),
    ...mapGetters("reciever", ["getWhatsappConfig", "isWhatsappAdded"]),
    maxLineLength() {
      return this.isSmallPrinter ? 31 : 48;
    },
    isSmallPrinter() {
      return this.$ls.get("printer-type", "md") == "sm";
    },
    isUpdatedQz() {
      return this.locationDetails.qz_upgrade;
    }
  },
  methods: {
    // ...mapActions("reciever", ["updatePrintStatus"]),
    ...mapMutations("restaurant", ["SET_QZ_CONNECTION_STATUS"]),
    initQzSettings() {
      console.log("Qz DEBUGGER ::: initQzSettings()");
      const CERTIFICATE = this.locationDetails.qz_upgrade
        ? "-----BEGIN CERTIFICATE-----\n" +
          "MIIEwDCCAqigAwIBAgIQNzkyMDI0MTAxNjA2NDkxNzANBgkqhkiG9w0BAQsFADCB\n" +
          "mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry\n" +
          "aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ\n" +
          "cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz\n" +
          "dHJpZXMuY29tMB4XDTI0MTAxNjA2NDkxN1oXDTI1MTAxNjA3NDQzNVowejELMAkG\n" +
          "A1UEBgwCSU4xCzAJBgNVBAgMAktMMQ4wDAYDVQQHDAVLb2NoaTEOMAwGA1UECgwF\n" +
          "Rm9hcHMxDjAMBgNVBAsMBUZvYXBzMQ4wDAYDVQQDDAVGb2FwczEeMBwGCSqGSIb3\n" +
          "DQEJAQwPbWlnZGFkQGZvYXBzLmNvMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIB\n" +
          "CgKCAQEAnWQ2I0CeT5b0heQgOu/kZhaj1WTYnSHK0WrcBQsSDNU4bCF/qVJArg9G\n" +
          "51k9yIzV1uAUP2DRHAm+ZHIO7tMBtlTVaYJQBN21JSVwcpGZ/qQNJ3AHL856fyLi\n" +
          "CELDXSJnnCgYodImuyh5hhSNSvi2fJ/0/vfVEtL82p+xmAlKVY1jcIxiubTBvo3d\n" +
          "ZFs/dYeOIcGIuxc1yavJQWVcSJLtG+fcXhjUBqB+OJ9yPbpAosv2kuDAjmIaog3R\n" +
          "EhFfc/mS4Gn+6LPr4a6o+dBYI5r+WqYloQke2aCnNhghBl1XbMDw6N8kqcDx/ApU\n" +
          "vyewXn/yIs8IDPnzWjcfwB86r0Y3cwIDAQABoyMwITAfBgNVHSMEGDAWgBSQplC3\n" +
          "hNS56l/yBYQTeEXoqXVUXDANBgkqhkiG9w0BAQsFAAOCAgEAXhrwB7jYwLEW50bU\n" +
          "A2D6eyv4zzjks31yNVtCyvphu7+BAGuxjl39kxNbBadyVOHXvuuy/KAGxQlZOzNv\n" +
          "BQB75qwqAWwks07zgJ58cBv/O/Wsl8M2MPAsPJnh1B+pOantHp+6hMhTxVrddxgS\n" +
          "NJ6p8f18/77Gdj3n5b3RcYxgRSo3Xmxn73Q2TS0a5VrcjFpu4mm9MVvEn4EKINxv\n" +
          "dIHUduTA6jVzwblFoPYBc/8/i4tuZ07YBUOkr8RfU7v7MMk05H+Y+y31JydUNZ2L\n" +
          "schVdQabYJ2aMDHFgHEuDB/qQhZFNmGQnOnbdItRkTuVa5hUvxmgivx04p3JBgYa\n" +
          "r1kvudb9zfXi5tQiJ60X0CywZB9bWUozl3tu/hYqovbz8ewZ0Ixx1IrRhXEN/ZdN\n" +
          "KlYJzIx8mDfxk8xRJyZ3AdA9ZTLfNaUi0Nj+wLVTVtb8QD90OQYJVf25YC1azITG\n" +
          "j/x4QaTiyTHbo8jT+UUFYAyJtZ9KY5MrOeM/PqgJtIbDuXiI7TNzG4jA4azRC5tr\n" +
          "8x31Dt5XGvsihIlHf6ERAUgW2EqDUHqA4t7Mx0a1WzaAchng15s64ugh7Gj5m1L3\n" +
          "IoVytlvbBMby1OM3qJ3bss4F61ihhCxBowTWLwXTEAMc6t7j8XFAler9Ze0LbWCL\n" +
          "6INsMNcUnu6nhlKIFXc0R6ZXdvg=\n" +
          "-----END CERTIFICATE-----\n" +
          "--START INTERMEDIATE CERT--\n" +
          "-----BEGIN CERTIFICATE-----\n" +
          "MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT\n" +
          "MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ\n" +
          "bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG\n" +
          "A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx\n" +
          "emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow\n" +
          "gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0\n" +
          "cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM\n" +
          "EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1\n" +
          "c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU\n" +
          "iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H\n" +
          "YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM\n" +
          "GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH\n" +
          "EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh\n" +
          "0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX\n" +
          "xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1\n" +
          "9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE\n" +
          "ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD\n" +
          "2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX\n" +
          "6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY\n" +
          "5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ\n" +
          "plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S\n" +
          "BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ\n" +
          "eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k\n" +
          "gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT\n" +
          "x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu\n" +
          "pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw\n" +
          "2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp\n" +
          "rbO7BnjW\n" +
          "-----END CERTIFICATE-----"
        : "-----BEGIN CERTIFICATE-----\n" +
          "MIIEBTCCAu2gAwIBAgIJAKixF+zMmacwMA0GCSqGSIb3DQEBCwUAMIGYMQswCQYDVQQGEwJJTjELMAkGA1UECAwCS0wxDzANBgNVBAcMBkNvY2hpbjEkMCIGA1UECgwbTGFzcGVyIFRlY2hub2xvZ2llcyBQdnQgTHRkMREwDwYDVQQLDAhmb2Fwcy5jbzETMBEGA1UEAwwKKi5mb2Fwcy5jbzEdMBsGCSqGSIb3DQEJARYOaGVsbG9AZm9hcHMuY28wHhcNMTcxMjAzMDUxNTM4WhcNNDkwNTI4MDUxNTM4WjCBmDELMAkGA1UEBhMCSU4xCzAJBgNVBAgMAktMMQ8wDQYDVQQHDAZDb2NoaW4xJDAiBgNVBAoMG0xhc3BlciBUZWNobm9sb2dpZXMgUHZ0IEx0ZDERMA8GA1UECwwIZm9hcHMuY28xEzARBgNVBAMMCiouZm9hcHMuY28xHTAbBgkqhkiG9w0BCQEWDmhlbGxvQGZvYXBzLmNvMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAud0e7VE1ChAbslwMpZL2Pc0PhEQTsA6pLX6irNlDdm+IVzwhIFK6dulzVoHHounUhivcFQ6ziq9igEe7CaMKYIs6Gt9hP+oQMIbtUTNqtUHQM//Iu2d3k20PY/CAAfL+40R0BQZOEDzkzxZb8D3S7ATliW1foVDVRXRuOfXfMVO/zY5EbxD9dqtDEm1OUHqVVNNy2np7xMapVmtdoGfoyKZ7rpH8kUHI2o3DucuLTVMWRAlQh+VZSs31bkgRNskWypEL8VhGN8p7mV3AKgQe2BGa2pfC/ewGAKxEZ/Ur+8lw0SFoBlYe4LU2vc9NKlnOj+qfQblVZ6/xqOoloSLLxQIDAQABo1AwTjAdBgNVHQ4EFgQUxS2x9T8eNe49Crji01SmYxzXxL4wHwYDVR0jBBgwFoAUxS2x9T8eNe49Crji01SmYxzXxL4wDAYDVR0TBAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAQEAf4qfKBuNmY5keLqi7yKPDlOeiScbS2SOrYBhoYFu0w87d6+Dr1XSeRYO+yDYlQnN6OGGzuTiqZWOEE4PLMmM7H7xH470meAnPMfQcWJ+qi/UARnrDURoB762v2jF05Xz4nKulUWq5j4lgFyAc46ved/pp8agMYVV6CTeAFABpEfm+oiAHew34Wo5ICyUvE05Rwjj0VMT1JIKCQ6vP4ReG8JIqovmaRDcCKoJ8Kadn0s4RiS5Twima9ptwxMEzRN2XVhXVprsKTDE7l6BnoN+JQUgTFTBsGyzyk0t+oZJEiBcokfFBWyEAHodAUrW/Id6DJbnddAO/EQIV/pqOZPIvA==\n" +
          "-----END CERTIFICATE-----";

      const PRIVATE_KEY = this.locationDetails.qz_upgrade
        ? "-----BEGIN PRIVATE KEY-----\n" +
          "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCdZDYjQJ5PlvSF\n" +
          "5CA67+RmFqPVZNidIcrRatwFCxIM1ThsIX+pUkCuD0bnWT3IjNXW4BQ/YNEcCb5k\n" +
          "cg7u0wG2VNVpglAE3bUlJXBykZn+pA0ncAcvznp/IuIIQsNdImecKBih0ia7KHmG\n" +
          "FI1K+LZ8n/T+99US0vzan7GYCUpVjWNwjGK5tMG+jd1kWz91h44hwYi7FzXJq8lB\n" +
          "ZVxIku0b59xeGNQGoH44n3I9ukCiy/aS4MCOYhqiDdESEV9z+ZLgaf7os+vhrqj5\n" +
          "0Fgjmv5apiWhCR7ZoKc2GCEGXVdswPDo3ySpwPH8ClS/J7Bef/IizwgM+fNaNx/A\n" +
          "HzqvRjdzAgMBAAECggEACRD55LZMXZr9U0MiBNMceIcAVq1cTvzggTINzNqSO8at\n" +
          "MolhdbWlFSxlx14xfBPPc5/CetN5vYrleprEDRzUN0EUGWOmIV72GCwxGeBqRawE\n" +
          "jUuGQR+R7dtADagZjIwL+jJTF5Xn9kBYHmb2VqW/ZAFrgaPGvzKuhGzONEsAta8m\n" +
          "s6PTZW4Uu5zhNXd/5mXCRaULfd327tqWznV8aJ1DzWZqcqG4s1SHiDq8pu14Er5U\n" +
          "7xYlfK3eywr1ZgnaCOa/bpKd3FT6ALQLysJAfnkU//p5jFafbklYXtVnxPFdefmq\n" +
          "GUqfOThcyF9MKDvzgcSProTPsxL4tc+BODoKVGckBQKBgQDN5oskHYnueorDxwfO\n" +
          "i+5QFVMTirPJ6yPJXiPZH820OzX7EN1Y4og1gHqi9Rk4YQp9M2CsZbxepy98TOVh\n" +
          "c4V19dKko1y8RPRd2hve5adojynPJdDUcTl7qPm9u8j0R344C9dEdkDZHL8bBjMC\n" +
          "tZdjVI5w+laI/JZO5u5gv9w+7wKBgQDDsA587D41VKb3r23FtOApavNb9TEbgJOp\n" +
          "4HSvZkZorHcTPd9zEWLIzyLilml4z0YOaskVj4zCR/EecSiv42ZV/fK40KL3H9DD\n" +
          "Ero1ihwsFXVipMESKg3c6V5zlnOg4zPdyi/Q11x5KPocCp29JrSg/xDY5yu7PAkb\n" +
          "o+J1EcBPvQKBgBbPH0LU8t60PIMLnVXIMpI0iotzpg8MOV6pSxdWapc4p/Y0HBEo\n" +
          "pyYmIW/D7xNLzLmp41+1tXRW2O/QJOjyvyoeHUOXxUIl8VwkOUor7quqkFseOVAP\n" +
          "aurEAUZ/cvd8pALZbPNslip3AMShny0BqM+cIltpoAR01sHO20Fkf6WJAoGBAI0S\n" +
          "iP9KGHa99jitQYe8I7X4IkTy+FoJUWqwI66nHq8rVhSLEGGV8Q8vNMkBAjxTwP93\n" +
          "wEtI14Lf9lWp4lkaqJXpo2fVEQby6r8W6yLZ1AF73sokWAPOSXwuySavGeCsqqGD\n" +
          "twDpoQK/pb89cAYCt0kxWGXmEcLDPxWsCf+3slpJAoGAVvbkajGaBb+XQP3Q/4ls\n" +
          "BNhQU7z02nmIwa+l7ySgm5GQlAqA7xZlsG+dlYgwtO1Jx3jxDB0gwpf2rf5sb3PT\n" +
          "wvfDd+UJHLLmuFSAY4aLxQG7ZrBokuHztTPbV17vHXsPnX7UsIatvxnifLWjQ2bE\n" +
          "iKUsZY3JD4XDPAsA69q+4Ug=\n" +
          "-----END PRIVATE KEY-----\n"
        : "-----BEGIN PRIVATE KEY-----\n" +
          "MIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQC53R7tUTUKEBuyXAylkvY9zQ+ERBOwDqktfqKs2UN2b4hXPCEgUrp26XNWgcei6dSGK9wVDrOKr2KAR7sJowpgizoa32E/6hAwhu1RM2q1QdAz/8i7Z3eTbQ9j8IAB8v7jRHQFBk4QPOTPFlvwPdLsBOWJbV+hUNVFdG459d8xU7/NjkRvEP12q0MSbU5QepVU03LaenvExqlWa12gZ+jIpnuukfyRQcjajcO5y4tNUxZECVCH5VlKzfVuSBE2yRbKkQvxWEY3ynuZXcAqBB7YEZral8L97AYArERn9Sv7yXDRIWgGVh7gtTa9z00qWc6P6p9BuVVnr/Go6iWhIsvFAgMBAAECggEAImO1ezeRVsFQPpolhOVCRoEQo+pssiCkUNSjiNPSVbGhSnLHtlFYSvQ68QCmTZByUDkBSawksD5vPUkIZGoUW3SnVZ2LQuYuBKyScHnQ/qSkv1pOa85jI5YESPuQ08uAOdDKnrth6kM6Gs8KR9NImX72cY0ZKqHoNCes1XCW0Wtav1UK7wKmJ8Kh+FYxAOynbnKI82K5dw3bjzWucEx8kDFWXjYQ0Hc0jVhfOTnSru6QrgnoUqPHVwv1o5Xd8xlV1lUPL+noi5Hrl6MQtjzheoTqkh2Gfgmq5BS/vAsVK6/0lAoPcCvLq/rZ0fV+i8GYIagXjYgOhALLECR23i+gaQKBgQDj750jgDofIn8TowMHukIJ4C2VDLegrhFWrbylEEhpDgDMj+d7bhD18SvqzMxB9D1NRTtOwoUncoW6f6BbK8myADokVXaJJR0cKlItPj+4pXS+PokbCSLeM6DPgyw7CUX4ADgjP8I3KyIOYfl86pvE6O2cDDmS14PzB8w+3qElmwKBgQDQv2s7nfLA4/f18uUo1ojC9MESKY+/ZRbNt6VFNZOjGQ+Greus9DzrpJS25vq6csXShmnjRjJs0Dt221PH7N2CxqWpTxi+8RmRDjaXlIra1MjAQYdGeMXCDE2KPfF9/8pGW/s5f0dbiFe2IKcPxMj51Zkg+//HtoZ04IvUYQCaHwKBgQDANAp+qB7aqD0d8uSYPJB5QWdOezXQsVd/jus3CT72D0/PLz2UEGEO8roEuYM3zltu8AUtyct8Uw6/D+XJW2gtyBE/GC3nQbuFR46aBha3fhWuYo88k/yqAEEHGuZONeihUpYD6zy7RozmMemuUyrc5UmPv6NA1qi2Y4nwLc0XJwKBgQCYEGlQQ448H5VZMDjpV+bGhj9DOM2DcmN7NmWJli7XaAEcbgO5uS3LxteiqX5KZiNfahUmv9Mp20MGIV3VzOHMS2MQhBMVvVKPjZgNMeM46DrZeqLNnlsJMacmplsOG1DBkm3fA636qsaiYQTyArsY7BWhppE8beVirNSPwJ4MpwKBgQCN8Q5NJAC3ocBc12UwNTbrASvWOUl+Ae0pprtVcH8loLwv8S0H8ZkytX0dNpolYVFnolcIRJ7a1yIgy1m55EfbxxFiLjjV0WSa9f+bCOHVQzq6MJ9ZC97m6+h3jIoaDNTBoC9stHlJg3/Mb9nYJcFeVZL5mhV2eojB35XCwHenjg==\n" +
          "-----END PRIVATE KEY-----";
      // QZ Tray connection settings
      console.log("Qz DEBUGGER ::: setCertificatePromise");
      qz.security.setCertificatePromise(function (resolve, reject) {
        console.log(
          "Qz DEBUGGER ::: setCertificatePromise->resolve",
          CERTIFICATE
        );
        resolve(CERTIFICATE);
      });

      console.log("Qz DEBUGGER ::: setSignaturePromise");
      qz.security.setSignaturePromise(function (toSign) {
        return function (resolve, reject) {
          try {
            // var pk = new RSAKey();
            // pk.readPrivateKeyFromPEMString(strip(PRIVATE_KEY));
            // var hex = pk.signString(toSign, 'sha1');
            // console.log("DEBUG: \n\n" + stob64(hextorstr(hex)));
            // resolve(stob64(hextorstr(hex)));
            var pk = KEYUTIL.getKey(PRIVATE_KEY);
            var sig = new KJUR.crypto.Signature({ alg: "SHA1withRSA" });
            sig.init(pk);
            sig.updateString(toSign);
            var hex = sig.sign();
            //console.log("DEBUG: \n\n" + stob64(hextorstr(hex)));
            console.log(
              "Qz DEBUGGER ::: setSignaturePromise->resolve",
              PRIVATE_KEY
            );
            resolve(stob64(hextorstr(hex)));
          } catch (err) {
            console.error(err);
            reject(err);
          }
        };
      });
    },
    startConnection() {
      let config = { retries: 5, delay: 1, keepAlive: 50 };
      // if (
      //   /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)
      // ) {
      //   //if mobile device
      //   config = {
      //     ...config,
      //     host: "IPv4.ADDRESS.OF.LAN-PRINT-SERVER",
      //     usingSecure: false
      //   };
      // }
      var vm = this;
      console.log("Qz DEBUGGER ::: startConnection()", config);

      if (!qz.websocket.isActive()) {
        // this.$toasted.show("Connecting to printer!!");
        console.log("Qz DEBUGGER ::: startConnection->not active");

        qz.websocket
          .connect(config)
          .then(function () {
            // vm.getSystemInfo();
            console.log("Printer connected. Send finger print");
            vm.SET_QZ_CONNECTION_STATUS(true);
            console.log("Qz DEBUGGER ::: startConnection->connect->then");
            //vm.$toasted.show("Connected to Printer!!")
          })
          .catch(function (e) {
            console.log("Qz DEBUGGER ::: startConnection->connect->catch", e);
            vm.SET_QZ_CONNECTION_STATUS(false);
            console.log(e);
          });
      } else {
        console.log("An active connection with QZ already exists.");
      }

      vm.$nuxt.$on("printer-disconnected", () => {
        vm.SET_QZ_CONNECTION_STATUS(false);
      });
    },
    async selectDefaultPrinter(defaultPrinter = null) {
      return (defaultPrinter = await qz.printers
        .getDefault()
        .then(function (defaultPrinter) {
          console.log("defaultprinter:: ", defaultPrinter);
          return defaultPrinter;
        }));
    },
    getBoldOff() {
      return this.isAndroid() ? "" : "\x1B" + "\x45" + "\x0A";
    },
    isFoodSafetyEnabled() {
      return this.getBoolean(this.$ls.get("health-message", true));
    },
    isBarcodeEnabled() {
      return this.getBoolean(this.$ls.get("print-barcode", false));
    },

    isKotMarketingEnabled() {
      return this.$ls.get("kot-marketing", false);
    },
    printLogoImage() {
      return this.getBoolean(this.$ls.get("print-logo-image", true));
    },
    getEmptySpaceContent() {
      const emtySpaces = Number(this.$ls.get("empty-space", 8));
      return "\x0A".repeat(emtySpaces);
    },
    async initiatePrint(
      order,
      type,
      fetchData,
      part,
      dispatch,
      copy,
      isOnlineOrder,
      selectedPrinters,
      source
    ) {
      var vm = this;
      var items = [];
      var printJobCount = 0;
      if (!qz.websocket.isActive() && !this.isAndroid()) {
        //Retry 5 times, pausing 1 second between each attempt
        this.startConnection({ retries: 5, delay: 1, keepAlive: 50 }); //this.printKOT()
        $nuxt.$emit(
          "show-error-toast",
          "Printer not found. Retrying to connect..."
        );
        // vm.$toasted.show("Printer not found. Retrying to connect...");
      } else {
        // if (fetchData || (isOnlineOrder && !isSocket)) {
        //   // force fetch if online data and not socket
        //   if (isOnlineOrder) {
        //     this.zomatoOrderDetails(
        //       order.id,
        //       type,
        //       dispatch,
        //       copy,
        //       isOnlineOrder
        //     );
        //   } else {
        //     this.fetchOrderDetails(order.id, type, dispatch, copy); //fetch and print
        //   }
        // } else

        this.barcodeImage = this.getBarcodeImage(order);
        if (this.isHtmlPrintingEnabled()) return;
        if (type === "bill") {
          const defaultPrinter = await vm.selectDefaultPrinter();
          printJobCount++;
          this.printJob(
            "foaps-bill",
            order,
            "bill",
            part,
            dispatch,
            copy,
            null,
            isOnlineOrder,
            defaultPrinter,
            source
          ); //foaps-bill
        } else if (type === "kot") {
          if (this.isAndroid()) {
            printJobCount++;
            vm.printJob(
              "foaps-kot",
              order,
              "ticket",
              part,
              false,
              false,
              null,
              isOnlineOrder,
              { id: "bluetooth" },
              source,
              order.items
            );
          } else {
            selectedPrinters.forEach((printer) => {
              items = order.items.filter((item) => {
                return (
                  !item.kot_disabled &&
                  item.printer_id &&
                  item.printer_id == printer.id
                );
              });
              if (items && items.length) {
                printJobCount++;
                vm.printJob(
                  "foaps-kot",
                  order,
                  "ticket",
                  part,
                  false,
                  false,
                  null,
                  isOnlineOrder,
                  printer,
                  source,
                  items
                );
              }
            });
          }
          // console.log(
          //   "Printing kot without fetch" + vm.loadedPrinters.toString()
          // );
          // if (vm.loadedPrinters.length) {
          //   for (var i = 0; i < vm.loadedPrinters.length; i++) {
          //     console.log("PRRRRRRRRRRRRRRRRRRrinter + " + i);
          //     console.log(vm.loadedPrinters[i]);
          //     //setTimeout(function(){
          //     vm.printJob(
          //       vm.loadedPrinters[i].name,
          //       order,
          //       "ticket",
          //       part,
          //       false,
          //       false,
          //       vm.loadedPrinters[i].id,
          //       isOnlineOrder
          //     );
          //     //},2000)
          //   }
          // } else {

          // }
        } else if (type === "master-kot" && !this.isAndroid()) {
          const masterPrinters = this.printers.filter(
            (printer) => printer.is_master_printer
          );
          masterPrinters.forEach((masterPrinter) => {
            printJobCount++;
            vm.printJob(
              "foaps-kot",
              order,
              "ticket",
              part,
              false,
              false,
              null,
              isOnlineOrder,
              masterPrinter,
              source,
              order.items,
              type
            );
          });
        } else if (type === "report-kot") {
          let defaultPrinter;
          printJobCount++;
          const reportData = await vm.addReportContent(order);
          if (this.isAndroid()) {
            defaultPrinter = { id: "bluetooth", name: "bluetooth" };
          } else {
            defaultPrinter = await vm.selectDefaultPrinter();
          }
          await vm.sendDataToPrinter(
            defaultPrinter?.name,
            reportData,
            order,
            type,
            defaultPrinter
          );
          vm.$nuxt.$emit("report-print-completed");
        } else {
          console.log("what???");
        }
        if (printJobCount == 0) {
          // $nuxt.$emit("show-error-toast", "Sorry, nothing to print!");
          $nuxt.$emit("print-completed");
        }
      }
    },

    async printJob(
      printerName,
      order,
      type,
      part,
      dispatch,
      copy,
      printerid,
      isOnlineOrder,
      selectedPrinter,
      source,
      items,
      typeFlag // for master KOT implementation
    ) {
      var vm = this;
      var data = [];
      //console.log(JSON.stringify(order))
      if (type === "bill") {
        if (isOnlineOrder) {
          console.log("Printing online order");
          var billdata = await vm.addBillContentOfOnlineOrder(
            order,
            dispatch,
            copy
          );
        }
        // else {
        //   cosnole.log("BILL not an online order");
        //   var billdata = await vm.addBillContent(order, dispatch, copy);
        // }
        //console.log('xd is')
        console.log(billdata);
        data = data.concat(billdata);
        vm.sendDataToPrinter(printerName, data, order, type, selectedPrinter);
        // }
      } else {
        //var tokendata = await vm.addTokenContent(order, part, printerid)

        if (isOnlineOrder) {
          var tokendata = await vm.addTokenContentOnline(
            order,
            1000,
            selectedPrinter.id,
            items,
            source,
            typeFlag
          );
        } else {
          // var tokendata = await vm.addTokenContent(order, part, printerid);
        }
        console.log("----TOKEN DATA-----");
        console.log(tokendata);
        if (tokendata.length) {
          data = data.concat(tokendata);

          vm.sendDataToPrinter(printerName, data, order, type, selectedPrinter);
        } else {
          console.log("Nothing to print to printerID: KOT " + printerid);
          $nuxt.$emit("show-error-toast", "Printer not found!");
          $nuxt.$emit("print-completed");
        }

        //}
      }
    },

    async sendDataToPrinter(printerName, data, order, type, selectedPrinter) {
      var vm = this;
      var restaurant = this.locationDetails;
      var config;
      // let selectedPrinter = await vm.findPrinter(printerName);
      // console.log("selectedPrinter is " + selectedPrinter);
      try {
        if (this.isAndroid()) {
          Android.initBluetoothPrint(data.join(""));
        } else {
          config = qz.configs.create(selectedPrinter, {
            jobName: "Foaps #" + order.id
          });
          if (restaurant?.logoPrintEnabled && type === "bill") {
            var LogoData = [{ type: "image", data: null }];
            LogoData.data = "/img/launcher-icon.png";
            qz.print(config, LogoData) // Print logo
              .then(function () {
                // then print bill
                return qz.print(config, data);
              })
              .then(function () {
                vm.updateStatusOfPrint(order, type);
              })
              .catch(function (e) {
                console.error("QZ error::: ", e);
                $nuxt.$emit(
                  "show-error-toast",
                  'Could not find the printer. Please reload the "Qz Tray" if printer name has changed.'
                );
                $nuxt.$emit("print-completed");
                e.source = "Error selecting Printer";
                // _LTracker.push(e);
              });
          } else {
            qz.print(config, data)
              .then(function () {
                vm.updateStatusOfPrint(order, type);
              })
              .catch(function (e) {
                console.error("QZ error::: ", e);
                $nuxt.$emit(
                  "show-error-toast",
                  'Could not find the printer. Please reload the "Qz Tray" if printer name has changed.'
                );
                $nuxt.$emit("print-completed");
                // vm.$toasted.show(
                //   'Could not find the printer. Please reload the "Qz Tray" if printer name has changed.'
                // );
                // e.source = "Error selecting Printer";
                // _LTracker.push(e);
              });
          }
        }
      } catch (e) {
        $nuxt.$emit(
          "show-error-toast",
          "Sorry, something went wrong with the printer"
        );
        $nuxt.$emit("print-completed");
      }
    },
    itemOptions(item) {
      let toAdd = [];
      if (item && Array.isArray(item.options_to_add)) {
        for (let j = 0; j < item.options_to_add.length; j++) {
          toAdd.push(item.options_to_add[j].title);
        }
      }
      return toAdd;
    },
    updateStatusOfPrint(order, type) {
      console.log("Qz print SUCCESS", type);
      if (type === "ticket") {
        console.log("need to update kot_print_status: 2");
        this.handleUpdatePrintStatus(order, "kot");
      } else if (type === "bill") {
        console.log("need to update bill_print_status: 2");
        this.handleUpdatePrintStatus(order, "bill");
      }
    },
    handleUpdatePrintStatus(order, type) {
      var vm = this;
      // var obj = {
      //   order: {},
      //   // platform: "web",
      //   // "access-token": this.getTk(),
      //   // client: Vue.ls.get("client", ""),
      //   // expiry: Vue.ls.get("expiry", ""),
      //   // "token-type": Vue.ls.get("token-type", ""),
      //   // uid: Vue.ls.get("uid", ""),
      // };
      console.log("Request to update printer status: " + type);
      let obj = { order: {} };
      if (type === "bill") {
        obj.order.bill_print_status = 2;
      } else if (type === "kot") {
        obj.order.kot_print_status = 2;
      }

      //generate hash to prevent duplicate Printing
      //vm.addToPrintQueue(order)

      // this.updatePrintStatus({ order, obj }).then(function (response) {
      //   if (response.data.status === "success") {
      //     console.log("updatePrintStatus Done.");
      //     $nuxt.$emit("print-completed");
      //   } else {
      //     // this.fireError(response);
      //   }
      //   return true;
      // });
    },
    addRequiredSpaces(text, charLength, dotsRequired, beginning) {
      const reducer = Number(this.$ls.get("print-width-reduce", 0));
      charLength -= reducer;
      var text = (text && text.toString()) || "";
      if (text.length > charLength) {
        if (dotsRequired) {
          text = text.substr(0, charLength - 3);
          text += "...";
        } else {
          text = text.substr(0, charLength);
        }
      } else {
        var remainingChars = charLength - text.length;
        var spaces = "";
        for (var i = 0; i < remainingChars; i++) {
          spaces += " ";
        }
        if (beginning) {
          text = spaces + text;
        } else {
          text = text + spaces;
        }
      }
      return text;
    },
    toMultipleLines(text, length) {
      var t = "";
      var lineTexts = [];
      var s = text.split(" ");
      var maxLength = length; // of one line
      var lines = "";
      //var para = []
      var totalLength = 0;
      //console.log('s length: '+s.length)
      s.forEach(function (w, indx) {
        totalLength += w.length;
        //console.log('word being checking: "'+w + '" and totalLength ' +totalLength)
        if (w.length >= maxLength) {
          //console.log(w + ' -'+  w.length+' is longer than '+ maxLength)
          for (var l = 0; l < w.length; l++) {
            t += w[l];
            //console.log('t = ' + t)
            if (l != 0 && l % maxLength == 0) {
              //console.log('one line finished: Text: ' + t)
              lineTexts.push(t.trim());
              t = "";
            } else if (l == w.length - 1) {
              //console.log('pushing '+ t)
              //lineTexts.push(t.trim())
              lines = t;
            }
          }
          totalLength = t.length;
        } else if (totalLength < maxLength) {
          //console.log('totalLength < maxLength' + w +' is less than ')
          if (indx == 0) {
            lines = w;
          } else {
            lines += " " + w;
          }
          totalLength += 1; //space
          //console.log('not pushing the lines is = ' + lines)
          if (s.length == indx + 1) {
            //console.log('all words are finished. Pushing line '+ lines)
            lineTexts.push(lines);
          }
        } else {
          //console.log('ELSE: word is "' + w + '" pushing the lines: '+ lines)
          lineTexts.push(lines);
          lines = w;
          //console.log('line pushed and the new line is now ' + lines)
          if (s.length == indx + 1) {
            //console.log('Else is finished ' + lines)
            lineTexts.push(lines);
          }
          totalLength = w.length;
          //console.log('totalLength reset to ' + totalLength)
        }
      });
      return lineTexts;
    },
    addDevider() {
      const reducer = Number(this.$ls.get("print-width-reduce", 0));
      const effectiveReducer = Math.max(reducer, 0); // ignore negative values
      const lineLength = this.isSmallPrinter
        ? 30
        : this.MAX_CHAR_LENGTH - effectiveReducer;
      return (
        "\x0A" +
        "\x1D" +
        "\x21" +
        "\x00" +
        Array(lineLength).fill("-").join("") +
        "\x0A"
      );
    },
    addReportContent(items) {
      var data = [];
      const vm = this;

      data.push(
        "\x1D" + "\x21" + "\x11", // double font size;
        "\x1B" + "\x61" + "\x31", // center align,
        "Item-Wise Report",
        "\x0A"
      );
      data.push(
        "\x1D" + "\x21" + "\x00", // standard font size
        "\x1B" + "\x61" + "\x31", // center align,
        `  From ${this.$nuxt.$store.state?.report?.selectedStartDate} To ${this.$nuxt.$store.state?.report?.selectedEndDate}`,
        "\x0A"
      );
      data.push(
        //'\x0A',
        //'\x0A',
        // '\x1D' + '\x4C' +'1,2', ////////////////left margin to 0
        "\x1B" + "\x61" + "\x30", //left align
        this.addDevider(),
        "    Item                    Qty       Amt" + "\x0A",
        this.addDevider()
      ); // left align
      items.forEach((item) => {
        data.push("\x1B" + "\x61" + "\x30"); //left align
        data.push(
          "    " +
            vm.addRequiredSpaces(item.name, 23, false, false) +
            "  " +
            vm.addRequiredSpaces(item.qty, 5, false, false) +
            vm.addRequiredSpaces(item.total, 8, false, true) +
            "\x0A" +
            "\x1B" +
            "\x61" +
            "\x30"
        );
      });
      data.push("\x0A", "Powered by foaps.co", "\x0A");
      data.push(this.getEmptySpaceContent());
      data.push(
        "\x1B" + "\x69" // cut paper
      );
      return data;
    },
    addBillContentOfOnlineOrder(order, dispatch, copy) {
      var restaurant = JSON.parse(JSON.stringify(this.locationDetails));
      restaurant.address = restaurant.name || restaurant.address || "";
      restaurant.name = this.businessDetails.name || restaurant.name || "";
      var data = [];
      var vm = this;
      if (dispatch) {
        var delivery_address = order.delivery_address || "";
        var customer_mobile = order.customer_mobile || "";
        data.push(
          "\x1B" + "\x40", // init
          "\x1B" + "\x61" + "\x31", // center align
          "------------------------------------------" + "\x0A" + "\x0A",
          "\x1D" + "\x21" + "\x11", // double font size
          "Home Delivery : " + vm.formatDigit(order.token_id, 3) + "\x0A",
          "\x1D" + "\x21" + "\x00", // standard font size
          "------------------------------------------" + "\x0A",
          "\x1B" + "\x61" + "\x30", //left align
          "Date : ",
          vm.formatDate(null, false) + "\x0A",
          "Bill: # " + vm.formatDigit(order.invoice_id, 5) + "\x0A"
        );
        data.push("Channel: " + vm.formatText(order.source) + "\x0A");
        data.push("Customer Mobile : " + customer_mobile, "\x0A");
        var lineTexts = vm.toMultipleLines(delivery_address, 30);
        lineTexts.forEach(function (l, indx) {
          var name = l; //vm.addRequiredSpaces(l, 45, true,false)
          if (indx == 0) {
            data.push("Address: " + name + "\x0A");
          } else {
            data.push("         " + name + "\x0A");
          }
        });
        data.push(this.getEmptySpaceContent());
        data.push("\x1B" + "\x69");
      } else {
        data.push(
          //'\x1B' + '\x40',          // init
          "\x1B" + "\x61" + "\x31", // center align
          //vm.formatText(order.order_type) + 'Order',
          //'\x0A',
          //'_________________________________________'+ '\x0A' + '\x0A',
          //'\x1D' + '\x21' + '\x11', // double font size
          //'Token Number :' + vm.formatDigit(order.token_id, 3) + '\x0A',
          "\x1B" + "\x45" + "\x0D", // bold on
          restaurant?.name?.toUpperCase(),
          "\x0A",
          this.getBoldOff(), // bold off
          //'\x1D' + '\x21' + '\x00', // standard font size
          "\x1B" + "\x4D" + "\x31", // small font
          restaurant?.address,
          "\x0A",
          // "\x1B" + "\x45" + "\x0D", // bold on
          // "PH : " + restaurant?.country_code + " " + restaurant?.phone_number,
          // this.getBoldOff(), // bold off
          // "\x0A",
          "\x1B" + "\x4D" + "\x30" // normal text
        );
        if (restaurant?.gst_number) {
          //bold on
          data.push(
            "\x1B" + "\x45" + "\x0D",
            "GST NO ",
            restaurant?.gst_number.toUpperCase() + "\x0A",
            this.getBoldOff()
          );
        }
        data.push(
          "\x1B" + "\x61" + "\x30", //left align
          "------------------------------------------" + "\x0A",
          // '\x1D' + '\x21' + '\x11', // double font size
          //restaurant.name + '\x0A',
          "\x1D" + "\x21" + "\x00", // standard font size
          //'\x0A',                   // line break
          //'address' + '\x0A',     // text and line break
          this.isUpdatedQz ? "" : "\x0A", // line break
          //'\x1B' + '\x61' + '\x30', //left align
          //Waiter and table info
          "Bill    : #" +
            vm.addRequiredSpaces(
              vm.formatDigit(order.invoice_id, 5),
              14,
              false,
              false
            ) +
            " Date :" +
            vm.formatDate(null, false) +
            "\x0A"
        );
        var orderType = order.order_type;
        var charLength = 15;
        console.log(orderType.length);
        if (orderType.length > charLength) {
          orderType = orderType.substr(0, charLength) + "...";
        } else {
          var remainingChars = charLength - orderType.length;
          for (var i = 0; i < remainingChars; i++) {
            orderType += " ";
          }
        }
        data.push(
          "Type    : " +
            vm.addRequiredSpaces(vm.formatText(orderType), 16, false, false) +
            "Time :" +
            vm.formatDate(null, false, true) +
            "\x0A"
        );
        data.push(
          "Cashier : " +
            vm.addRequiredSpaces(restaurant?.name, 30, true, false) +
            "\x0A",
          "Channel  : " +
            vm.addRequiredSpaces(order.source || "", 30, true, false) +
            "\x0A",
          "Payment : " + order.mode,
          "\x0A"
        );
        // line break
        if (order.source_id) {
          data.push("Source Id: # " + order.source_id + "\x0A");
        }
        data.push(
          //'\x0A',
          //'\x0A',
          // '\x1D' + '\x4C' +'1,2', ////////////////left margin to 0
          "------------------------------------------" + "\x0A",
          "No. Items          Rt       Qty       Amt" + "\x0A",
          "------------------------------------------" + "\x0A",
          this.isUpdatedQz ? "" : "\x0A"
        ); // left align
        //Item info
        var listedItem = [];
        const comboFilteredItems =
          this.getItemListWithItemsAndCombos(order.items) || [];
        comboFilteredItems.forEach(function (item, indx, items) {
          var allitems = items;
          const isCombo = !!item.items?.length;
          var qty = parseFloat(isCombo ? item.combo_quantity : item.quantity);
          let itemOptionsToAdd = vm.itemOptions(item);
          var amt = 0;
          if (itemOptionsToAdd.length > 0) {
            var unitPrice = item.options_to_add.reduce(
              (a, c) => a + c.price,
              0
            );
            amt = qty * parseFloat(unitPrice);
          } else {
            var unitPrice = isCombo ? item.amount : item.unit_price;
            amt = qty * parseFloat(unitPrice);
          }
          amt = amt.toFixed(2);
          if (item.price_unit === "kilograms") {
            unitPrice = unitPrice + "/kg";
          }
          let itemString = "";
          if (itemOptionsToAdd.length) {
            itemString =
              (item.item_name || item.name) +
              "- " +
              itemOptionsToAdd.join(", ");
          } else {
            itemString = item.item_name || item.name;
          }
          var lineTexts = vm.toMultipleLines(itemString, 14);
          lineTexts.forEach(function (l, index) {
            if (lineTexts.length > 1) {
              if (index == 0) {
                data.push(
                  vm.addRequiredSpaces(parseInt(indx + 1), 4, false, false) +
                    l +
                    "\x0A"
                );
              } else if (index + 1 == lineTexts.length) {
                data.push("\x1B" + "\x61" + "\x30"); //left align
                data.push(
                  "    " +
                    vm.addRequiredSpaces(l, 15, false, false) +
                    vm.addRequiredSpaces(unitPrice, 10, false, false) +
                    vm.addRequiredSpaces(qty, 5, false, false) +
                    vm.addRequiredSpaces(amt, 8, false, true) +
                    "\x0A" +
                    "\x1B" +
                    "\x61" +
                    "\x30"
                );
                //data.push('    '+ vm.addRequiredSpaces(l, 15, false, false) + vm.addRequiredSpaces(unitPrice,10,false,false)+vm.addRequiredSpaces(qty,5,false,false)+'\x1B' + '\x61' + '\x32'+vm.addRequiredSpaces(amt,8,false,true)+'\x0A'+'\x1B' + '\x61' + '\x30')
              } else {
                data.push("    " + l + "\x0A");
              }
            } else {
              data.push("\x1B" + "\x61" + "\x30"); //left align
              data.push(
                vm.addRequiredSpaces(parseInt(indx + 1), 4, false, false) +
                  vm.addRequiredSpaces(l, 15, false, false) +
                  vm.addRequiredSpaces(unitPrice, 10, false, false) +
                  vm.addRequiredSpaces(qty, 5, false, false) +
                  vm.addRequiredSpaces(amt, 8, false, true) +
                  "\x0A" +
                  "\x1B" +
                  "\x61" +
                  "\x30"
              );
            }
          });
          listedItem.push(item.item_name + unitPrice);
        });
        data.push(
          "------------------------------------------" + "\x0A",
          this.isUpdatedQz ? "" : "\x0A",
          "\x1B" + "\x4D" + "\x30", // normal text
          vm.addRequiredSpaces("Item Charges", 29, true, true) +
            "  :" +
            vm.addRequiredSpaces(
              order?.unit_price_sum?.toFixed(2),
              10,
              false,
              true
            ),
          "\x0A"
        );
        data.push(
          vm.addRequiredSpaces("Discount", 29, true, true) +
            "  :" +
            vm.addRequiredSpaces(order.discount.toFixed(2), 10, false, true),
          "\x0A",
          "------------------------------------------" + "\x0A",
          this.isUpdatedQz ? "" : "\x0A",
          vm.addRequiredSpaces("Sub Total", 29, true, true) +
            "  :" +
            vm.addRequiredSpaces(order.base_amount.toFixed(2), 10, false, true),
          "\x0A",
          vm.addRequiredSpaces("Order Level Charges", 29, true, true) +
            "  :" +
            vm.addRequiredSpaces(
              order.order_level_total_charges.toFixed(2),
              10,
              false,
              true
            ),
          "\x0A",
          vm.addRequiredSpaces("Total Taxes", 29, true, true) +
            "  :" +
            vm.addRequiredSpaces(order.total_taxes.toFixed(2), 10, false, true),
          "\x0A"
        );
        var roundedOff = parseFloat(order.round_off);
        data.push(
          // vm.addRequiredSpaces("Rounding", 29, true, true) +
          //   "  :" +
          //   vm.addRequiredSpaces(this.getRounding(order), 10, false, true),
          // "\x0A",
          "\x1B" + "\x45" + "\x0D", // bold on
          "------------------------------------------" + "\x0A",
          this.isUpdatedQz ? "" : "\x0A",
          vm.addRequiredSpaces("Total Amount", 28, true, true) +
            "  :     " +
            parseFloat(order.payable_amount).toFixed(2),
          "\x0A",
          "------------------------------------------" + "\x0A",
          "\x1B" + "\x61" + "\x31"
        ); // center align
        if (restaurant.website) {
          data.push("\x0A", restaurant.website + "\x0A");
        }
        data.push(
          "\x0A",
          this.getBoldOff() // bold off
        );
        if (!copy) {
          data.push(
            "Thank you for visiting. Customers like you are",
            "\x0A",
            " our most valuable asset.",
            "\x0A"
          );
        }
        data.push("\x0A", "Powered by foaps.co", "\x0A");
        data.push(this.getEmptySpaceContent());
        data.push(
          "\x1B" + "\x69" // cut paper
        );
      }
      return data;
    },
    getRounding(order) {
      if (order && order.round_off) {
        return Math.abs(order.round_off) / 100;
      } else {
        return 0;
      }
    },
    addTokenContentOnline: function (
      order,
      part,
      printerid,
      items,
      source,
      typeFlag
    ) {
      console.log("Add token Content online...");
      const isOrderFontSmall =
        this.getBoolean(this.$ls.get("is-kot-small-font", false)) ||
        this.isSmallPrinter;
      var vm = this;
      const itemCharLength = isOrderFontSmall
        ? this.isSmallPrinter
          ? 25
          : 40
        : 20;
      const fontSize = isOrderFontSmall
        ? "\x1D" + "\x21" + "\x00" // standard font size
        : "\x1D" + "\x21" + "\x11"; // double font size;
      const boldness = isOrderFontSmall
        ? "\x1B" + "\x45" + "\x0D" // bold on
        : "";
      const lineBreaks = isOrderFontSmall ? "\x0A" : "";
      const qtyCharLength = 3;
      const data = [
        "\x1B" + "\x40", // init
        "\x1B" + "\x61" + "\x30" //left align
      ];
      // consolidated kot
      if (typeFlag === "master-kot") {
        data.push(
          "\x1B" + "\x61" + "\x31", // center align
          "\x1D" + "\x21" + "\x00", // standard font size
          "Consolidated KOT",
          "\x0A", // line break
          "\x1B" + "\x61" + "\x30" //left align,
        );
      }
      // Section 0 : Platform Logo
      // .........cancelled.......
      if (source == "orderCancelled") {
        if (this.isAndroid() || !this.printLogoImage()) {
          data.push(
            "\x0A",
            "\x1D" + "\x21" + "\x11", // double font size
            "\x1B" + "\x45" + "\x0D", // bold on
            "CANCELLED" + "\x0A"
          );
        } else {
          data.push({
            type: "raw",
            format: "image",
            flavor: "file",
            data: this.cancelledImg,
            options: { language: "ESCPOS", dotDensity: "double" }
          });
        }
      }
      // .........platform logo.......
      if (this.isAndroid() || !this.printLogoImage()) {
        data.push(
          "\x1D" + "\x21" + "\x11", // double font size
          "\x1B" + "\x45" + "\x0D", // bold on
          this.getChannelConstObj(order.source).label.toUpperCase() + "\x0A",
          "\x1D" + "\x21" + "\x00", // standard font size,
          "\x0A"
        );
      } else if (!this.isAndroid() && !isOrderFontSmall) {
        data.push({
          type: "raw",
          format: "image",
          flavor: "file",
          data: this.getChannelConstObj(order.source).logo,
          options: { language: "ESCPOS", dotDensity: "double" }
        });
      }
      // Section 1: Token, Order ID, OTP
      data.push(
        "\x1B" + "\x45" + "\x0D", // bold on
        "\x1D" + "\x21" + "\x11", // double font size
        "TOKEN: " + vm.formatDigit(order.token_id, 3),
        "\x0A",
        "ORDER ID: ",
        "\x1D" + "\x21" + "\x00", // standard font size
        order.source_id &&
          order.source_id.substring(0, order.source_id.length - 4),
        "\x1D" + "\x21" + "\x11", // double font size
        "\x1B" + "\x45" + "\x0D", // bold on
        order.source_id &&
          order.source_id.substring(order.source_id.length - 4),
        "\x1D" + "\x21" + "\x00", // standard font size
        "\x0A"
      );
      const orderOtp = this.getOtp(order);
      if (orderOtp) {
        data.push(
          "OTP:",
          orderOtp,
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A"
        );
      }
      // Section 2: Brand, Channel, Date, Time
      data.push(
        this.addDevider(),
        this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
          ? ""
          : "\x0A",
        "BRAND: " + this.getRestaurantName(order.restaurant_id).toUpperCase(),
        "\x0A",
        isOrderFontSmall || printerid === "bluetooth"
          ? "CHANNEL: " +
              this.getChannelConstObj(order.source).label.toUpperCase()
          : "",
        isOrderFontSmall || printerid === "bluetooth" ? "\x0A" : "",
        "DATE: " + vm.formatDate(null, false),
        "\x0A",
        "TIME: " + vm.formatDate(null, false, true),
        "\x0A",
        this.getBoldOff() // bold off
      );
      const type = this.$constants.OrderTypes.ORDERTYPES.find(
        (t) => t.id === order.order_type
      );
      if (type.id) {
        data.push(
          "\x1B" + "\x45" + "\x0D", // bold on
          "ORDER TYPE: " + type.label.toUpperCase(),
          (this.isUpdatedQz && !isOrderFontSmall) ||
            isOrderFontSmall ||
            printerid === "bluetooth"
            ? ""
            : "\x0A"
        );
      }
      data.push(
        this.getBoldOff(), // bold off
        this.addDevider()
      );
      // Section 3: Ordered Items
      const totalItems = items.reduce((acc, item) => acc + item.quantity, 0);
      data.push(
        this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
          ? ""
          : "\x0A",
        "\x1B" + "\x45" + "\x0D",
        "ORDERED ITEMS (" + totalItems + ")",
        this.getBoldOff(), // bold off
        this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
          ? ""
          : "\x0A",
        this.addDevider(),
        this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
          ? ""
          : "\x0A"
      );
      items &&
        items.forEach((item, i) => {
          if (
            item.status == 0 ||
            (order.kot_print_status == 0 &&
              (order.order_type ===
                this.$constants.OrderTypes.HOME_DELIVERY.id ||
                order.order_type === this.$constants.OrderTypes.DELIVERY.id ||
                order.order_type ===
                  this.$constants.OrderTypes.TAKE_AWAY.id)) ||
            part
          ) {
            if (part && part != 1000) {
              if (item.kot_part != part) {
                console.log("item.kotpart " + item.kot_part + " != " + part);
                return;
              }
            }
            console.log("item.printer_id " + item.printer_id);
            if (
              typeFlag !== "master-kot" &&
              printerid !== "bluetooth" &&
              (item.kot_disabled ||
                (printerid && item.printer_id && item.printer_id != printerid))
            ) {
              console.log(
                "///////////////// printerid: " +
                  printerid +
                  "item.printer_id " +
                  item.printer_id +
                  "item" +
                  item.item_name
              );
              return;
            }
            let itemOptionsToAdd = vm.itemOptions(item);
            console.log(itemOptionsToAdd);
            // combining item name and options
            let itemString = "";
            if (itemOptionsToAdd.length) {
              itemString =
                (item.item_name || item.name) +
                "- " +
                itemOptionsToAdd.join(", ");
              console.log("with addons", itemString);
            } else {
              itemString = item.item_name || item.name;
              console.log("no addons", itemString);
            }

            itemString = isOrderFontSmall
              ? itemString.toUpperCase()
              : itemString;
            // quantity
            const qty =
              item.quantity + (item.price_unit === "kilograms" ? "kg" : "");
            // item name
            // itemString = itemString.toUpperCase();
            if (itemString.length > itemCharLength) {
              console.log("item length is longer>>>>>>>>>>>>>: " + itemString);
              var length = itemString.length;
              var lineTexts = vm.toMultipleLines(itemString, itemCharLength);
              console.log("Lines: " + JSON.stringify(lineTexts));
              lineTexts.forEach(function (l, indx) {
                console.log("l= " + l);
                var name = l; //vm.addRequiredSpaces(l, 45, true,false)
                console.log("name = " + name);
                if (indx == 0) {
                  console.log("index == 0");
                  data.push(
                    isOrderFontSmall
                      ? "\x1D" + "\x21" + "\x00"
                      : "\x1D" + "\x21" + "\x11",
                    // double font size
                    qty +
                      " x " +
                      vm.addRequiredSpaces(name, itemCharLength, true, false),
                    "\x1D" + "\x21" + "\x00", // standard font size
                    "\x0A"
                  );
                } else {
                  data.push(
                    isOrderFontSmall
                      ? "\x1D" + "\x21" + "\x00"
                      : "\x1D" + "\x21" + "\x11",
                    "  " + name,
                    "\x1D" + "\x21" + "\x00", // standard font size
                    "\x0A"
                  );
                }
              });
            } else {
              var name = vm.addRequiredSpaces(
                itemString,
                itemCharLength,
                true,
                false
              );
              const requiresLineBreak =
                !this.isUpdatedQz ||
                (this.isUpdatedQz &&
                  isOrderFontSmall &&
                  (i !== items.length - 1 || item.combo?.id));
              data.push(
                isOrderFontSmall
                  ? "\x1D" + "\x21" + "\x00"
                  : "\x1D" + "\x21" + "\x11", // double font size
                qty + " x " + name,
                "\x1D" + "\x21" + "\x00", // standard font size
                requiresLineBreak ? "\x0A" : ""
              );
            }
            if (item.combo?.id) {
              data.push(
                `  (COMBO : ${item.combo.name})`,
                "\x1D" + "\x21" + "\x00", // standard font size
                this.isUpdatedQz && i === items.length - 1 ? "" : "\x0A"
              );
            }
            // addons
            // let selectedOptions = itemOptionsToAdd.filter(
            //   (option) => item.selected_variant !== option
            // );
            // if (selectedOptions && selectedOptions.length > 0) {
            //   const addons = selectedOptions.map((addon) => addon).join(", ");
            //   data.push(
            //     isOrderFontSmall || printerid === "bluetooth" ? "" : "\x0A",
            //     "Add-ons: " + addons,
            //     isOrderFontSmall || printerid === "bluetooth" ? "" : "\x0A"
            //   );
            // }
          } else {
            console.log("this item " + itemString + " has already printed");
          }
        });
      data.push(this.addDevider());
      // Section 4: Customer Notes
      if (order.instructions && order.instructions.length > 0) {
        // const lines = vm.toMultipleLines(order.instructions, 24);
        // data.push(
        //   "\x0A", // remove line break
        //   fontSize,
        //   "Note:  "
        // );
        // lines.forEach(function (l, index) {
        //   if (index === 0) {
        //     data.push(l + "\x0A");
        //   } else {
        //     data.push(l + " ");
        //   }
        // });
        data.push(
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A",
          "\x1B" + "\x45" + "\x0D", // bold on
          "CUSTOMER NOTES",
          this.getBoldOff(), // bold off
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? "\x0A"
            : "\x0A" + "\x0A",
          order.instructions.toUpperCase(),
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A",
          this.addDevider()
        );
      }
      // Section 5: Delivery Details
      if (
        this.getChannelConstObj(order.source).name ===
          this.$constants.Channels.WHATSAPP.name &&
        order.delivery_address
      ) {
        data.push(
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A",
          "\x1B" + "\x45" + "\x0D", // bold on
          "DELIVERY DETAILS",
          this.getBoldOff(), // bold off
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? "\x0A"
            : "\x0A" + "\x0A",
          order.delivery_address.toUpperCase(),
          "\x0A",
          "Mobile no: ",
          order.customer_mobile,
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A",
          this.addDevider()
        );
      }
      // Section 6: Food Safety Instructions
      if (this.isFoodSafetyEnabled()) {
        data.push(
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? ""
            : "\x0A",
          "\x1B" + "\x45" + "\x0D",
          "FOOD SAFETY INSTRUCTIONS",
          this.getBoldOff(), // bold off
          this.isUpdatedQz || isOrderFontSmall || printerid === "bluetooth"
            ? "\x0A"
            : "\x0A" + "\x0A",
          "FOOD MUST BE CONSUMED WITHIN 2 HOURS OF DELIVERY",
          "\x0A"
        );
      }
      // Section 7: Barcode
      if (this.barcodeImage && !this.isAndroid()) {
        data.push(
          "\x0A",
          "\x0A",
          "\x0A",
          "\x0A",
          "\x0A",
          "\x1B" + "\x61" + "\x31", //center align
          {
            type: "pixel",
            format: "image",
            data: this.barcodeImage,
            options: { language: "ESCPOS", dotDensity: "double" }
          },
          "\x0A",
          "\x0A"
        );
      }
      // Section 8: Kot marketing
      if (this.getBoolean(this.isKotMarketingEnabled())) {
        const channelSelectedForKotMarketing = this.$ls.get(
          "selected-kot-marketing"
        );
        const kotMarketingMessage = this.$ls.get("kot-marketing-message");
        const canvasElement = this.getQrCodeImage(
          channelSelectedForKotMarketing
        );
        // Convert the canvas to base64 image
        const imageData = canvasElement.toDataURL("image/png");
        data.push(
          "\x0A",
          "\x0A",
          "\x0A",
          "\x1B" + "\x61" + "\x31", //center align
          {
            type: "raw",
            format: "image",
            data: imageData,
            options: { language: "ESCPOS", dotDensity: "double" }
          },
          "\x0A",
          "\x0A",
          "\x0A"
        );
        data.push("\x1D" + "\x21" + "\x00" + kotMarketingMessage);
      }
      // Section 9: Powered By
      data.push(
        "\x0A",
        "\x0A",
        "\x1B" + "\x61" + "\x31", //center align
        "Powered by foaps.co",
        "\x1B" + "\x61" + "\x30" //left align
      );
      data.push(this.getEmptySpaceContent());
      data.push(
        "\x0A",
        "\x1B" + "\x69", // cut paper
        "\x1B" + "\x42" + "\x03" + "\x03"
      );
      console.log("******************=====", data.toString());
      if (totalItems == 0) {
        return [];
      } else {
        return data;
      }
    },
    getBarcodeImage(order) {
      if (
        this.getChannelConstObj(order.source).name ===
          this.$constants.Channels.SWIGGY.name &&
        !order.status == 1 &&
        this.isBarcodeEnabled()
      ) {
        const barcode = new Vue({
          ...OrderBarcode,
          parent: this,
          propsData: {
            barcodeText: order.swiggy_barcode_id
          }
        }).$mount().$el;
        return barcode.querySelector("img").src;
      } else {
        return "";
      }
    },
    getQrCodeImage(channel) {
      let url = "";
      if (channel === "whatsapp") {
        url = this.getWhatsappOrderUrl(
          this.getWhatsappConfig.whatsapp_business_number
        );
      } else {
        // Search for the platform with the channel
        const selectedChannelObj =
          this.locationDetails.restaurants[0].restaurant_platforms.find(
            (platform) => platform.platform_name === channel
          );
        // setting the url
        if (selectedChannelObj) {
          url = selectedChannelObj.partner_url;
        }
      }
      const qrCode = new Vue({
        ...QrCode,
        parent: this,
        propsData: {
          value: url,
          size: 110,
          renderAs: "canvas"
        }
      }).$mount().$el;
      return qrCode.querySelector("canvas");
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("initiate-print");
    this.$nuxt.$off("re-start-connection");
    this.$nuxt.$off("printer-disconnected");
  }
};
